import { graphql } from "@/lib/gql/__generated__/gql";

export const DummyRoomNewItem_EditPage_Query = graphql(`
	query DummyRoomNewItem_EditPage($hotelID: ID!, $duplicateRoomID: ID) {
		roomDummyNewItem(hotelID: $hotelID, duplicateRoomID: $duplicateRoomID) {
			id
			hotelID
			roomID
			inSale
			availablePlanIDs
			maxRoomNum
			capacityPeopleMaximum
			capacityAdultMaximum
			capacityKidsMaximum
			isKidsUnavailable
			kidsPolicy {
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			name
			catchCopy
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				planID
				name
				id
			}
			secrets {
				planID
				name
				id
			}
		}
	}
`);
